export const issueEventTypeValues = [
	"Create",
	"Comment",
	"StatusChange",
	"LabelChange",
	"AssigneeChange",
	"DifficultyChange",
	"PriorityChange",
	"Delete",
	"Restore",
	"TitleChange",
	"DescriptionChange",
	"DueDateChange",
	"TeamChange",
	"ProjectChange",
	"BlockerChange"
] as const

export const issueCommentReactionTypeValues = [
	"ThumbsUp",
	"ThumbsDown",
	"PlusOne",
	"Rocket",
	"Fire",
	"Heart"
] as const

export const issueDifficultyValues = [1, 2, 3, 4, 5] as const

export const issuePriorityValues = [
	"None",
	"Low",
	"Medium",
	"High",
	"Urgent"
] as const

export const projectStatusValues = [
	"Planned",
	"InProgress",
	"Paused",
	"Complete",
	"Canceled"
] as const

export const ProjectStatus = Object.fromEntries(
	projectStatusValues.map((value) => [value, value])
) as { [K in (typeof projectStatusValues)[number]]: K }
export type ProjectStatus = (typeof projectStatusValues)[number]

export const issueStatusValues = [
	"ToDo",
	"InProgress",
	"InReview",
	"Complete",
	"Blocked",
	"Canceled",
	"Queue"
] as const

export const discordChannelModeValues = [
	"Queue",
	"Feed",
	"Suggestions"
] as const

export const contentTemplateKindValues = [
	"Issue",
	"Comment",
	"KnowledgeBase"
] as const

export const ContentTemplateKind = Object.fromEntries(
	contentTemplateKindValues.map((value) => [value, value])
) as { [K in (typeof contentTemplateKindValues)[number]]: K }
export type ContentTemplateKind = (typeof contentTemplateKindValues)[number]

export const suggestionSourceValues = ["Orbit", "Discord"] as const

export const notificationKindValues = [
	"Mention",
	"Assignment",
	"UpcomingDueDate",
	"PastDueDate",
	"WatchedIssueActivity",
	"ProjectUpdate",
	"JoinedOrg",
	"JoinedTeam",
	"TeamCreated",
	"TeamInvite",
	"DeliveryFailure"
] as const

export const notificationProviderValues = [
	"InApp",
	"Discord",
	"Email",
	"Native"
] as const

export const notificationDeliveryStatusValues = [
	"Pending",
	"Skipped",
	"Sent",
	"Failed"
] as const

export const issueWatcherSourceValues = [
	"Manual",
	"IssueCreator",
	"Commenter",
	"Mentioned"
] as const

export const IssueEventType = Object.fromEntries(
	issueEventTypeValues.map((value) => [value, value])
) as { [K in (typeof issueEventTypeValues)[number]]: K }
export type IssueEventType = (typeof issueEventTypeValues)[number]

export const IssueCommentReactionType = Object.fromEntries(
	issueCommentReactionTypeValues.map((value) => [value, value])
) as { [K in (typeof issueCommentReactionTypeValues)[number]]: K }
export type IssueCommentReactionType =
	(typeof issueCommentReactionTypeValues)[number]

export type IssueDifficulty = (typeof issueDifficultyValues)[number] | null

export const IssuePriority = Object.fromEntries(
	issuePriorityValues.map((value) => [value, value])
) as { [K in (typeof issuePriorityValues)[number]]: K }
export type IssuePriority = (typeof issuePriorityValues)[number]

export const IssueStatus = Object.fromEntries(
	issueStatusValues.map((value) => [value, value])
) as { [K in (typeof issueStatusValues)[number]]: K }
export type IssueStatus = (typeof issueStatusValues)[number]

export const DiscordChannelMode = Object.fromEntries(
	discordChannelModeValues.map((value) => [value, value])
) as { [K in (typeof discordChannelModeValues)[number]]: K }
export type DiscordChannelMode = (typeof discordChannelModeValues)[number]

export const SuggestionSource = Object.fromEntries(
	suggestionSourceValues.map((value) => [value, value])
) as { [K in (typeof suggestionSourceValues)[number]]: K }
export type SuggestionSource = (typeof suggestionSourceValues)[number]

export const NotificationKind = Object.fromEntries(
	notificationKindValues.map((value) => [value, value])
) as { [K in (typeof notificationKindValues)[number]]: K }
export type NotificationKind = (typeof notificationKindValues)[number]

export const NotificationProvider = Object.fromEntries(
	notificationProviderValues.map((value) => [value, value])
) as { [K in (typeof notificationProviderValues)[number]]: K }
export type NotificationProvider = (typeof notificationProviderValues)[number]

export const NotificationDeliveryStatus = Object.fromEntries(
	notificationDeliveryStatusValues.map((value) => [value, value])
) as { [K in (typeof notificationDeliveryStatusValues)[number]]: K }
export type NotificationDeliveryStatus =
	(typeof notificationDeliveryStatusValues)[number]

export const IssueWatcherSource = Object.fromEntries(
	issueWatcherSourceValues.map((value) => [value, value])
) as { [K in (typeof issueWatcherSourceValues)[number]]: K }
export type IssueWatcherSource = (typeof issueWatcherSourceValues)[number]

export const formFieldTypeValues = [
	"shortText",
	"longText",
	"number",
	"email",
	"phone",
	"url",
	"signature",
	"dropdown",
	"checkbox",
	"checkboxGroup",
	"radioGroup",
	"date",
	"fileUpload",
	"heading",
	"paragraph",
	"divider"
] as const

export const FormFieldType = Object.fromEntries(
	formFieldTypeValues.map((value) => [value, value])
) as { [K in (typeof formFieldTypeValues)[number]]: K }
export type FormFieldType = (typeof formFieldTypeValues)[number]

export const formShareAccessValues = ["anyone", "team", "org"] as const

export const FormShareAccess = Object.fromEntries(
	formShareAccessValues.map((value) => [value, value])
) as { [K in (typeof formShareAccessValues)[number]]: K }
export type FormShareAccess = (typeof formShareAccessValues)[number]

export type LogicCondition = {
	fieldId: string
	operator:
		| "equals"
		| "notEquals"
		| "contains"
		| "notContains"
		| "isEmpty"
		| "isNotEmpty"
	value?: string
}

export type FormFieldLogic = {
	action: "show" | "hide"
	conditions: LogicCondition[]
} | null

export const shareDurationValues = [
	"24h",
	"72h",
	"1w",
	"1mo",
	"forever"
] as const

export type ShareDuration = (typeof shareDurationValues)[number]
